/*
 * Keep the client-side "recently viewed" list in sync with products that are
 * still published to the Online Store. Inventory availability is deliberately
 * not used here: an active sold-out product is still a valid product page.
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'dvpp_rv';
  var GRID_SELECTOR = '#dvpp-rv-grid';
  var WRAP_SELECTOR = '#dvpp-rv-wrap';

  function productPath(value) {
    try {
      var url = new URL(value, window.location.origin);
      if (url.origin !== window.location.origin) return '';
      if (!/^\/products\/[^/]+\/?$/.test(url.pathname)) return '';
      return url.pathname.replace(/\/$/, '');
    } catch (error) {
      return '';
    }
  }

  function readList() {
    try {
      var parsed = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  }

  function writeList(list) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (error) {}
  }

  function checkProduct(entry) {
    var path = entry && productPath(entry.url);
    if (!path) {
      return Promise.resolve({ entry: entry, path: path, state: 'missing' });
    }

    return fetch(path + '.js', {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (response.ok) {
        return { entry: entry, path: path, state: 'active' };
      }
      if (response.status === 404 || response.status === 410) {
        return { entry: entry, path: path, state: 'missing' };
      }
      return { entry: entry, path: path, state: 'unknown' };
    }).catch(function () {
      // A temporary network failure must not permanently erase browsing history,
      // but the unverified card stays hidden for this page view.
      return { entry: entry, path: path, state: 'unknown' };
    });
  }

  function removeUnverifiedCards(results) {
    var states = {};
    results.forEach(function (result) {
      if (result.path) states[result.path] = result.state;
    });

    var grid = document.querySelector(GRID_SELECTOR);
    if (!grid) return;

    var cards = grid.querySelectorAll('.dvpp-pcard');
    for (var i = 0; i < cards.length; i += 1) {
      var link = cards[i].querySelector('a[href*="/products/"]');
      var path = link && productPath(link.getAttribute('href'));
      if (!path || states[path] !== 'active') cards[i].remove();
    }

    var wrap = document.querySelector(WRAP_SELECTOR);
    if (wrap && !grid.querySelector('.dvpp-pcard')) wrap.style.display = 'none';
  }

  function cleanRecentlyViewed() {
    var list = readList().slice(0, 12);
    if (!list.length) return;

    Promise.all(list.map(checkProduct)).then(function (results) {
      // Remove only products that Shopify confirms are no longer reachable.
      // Keep unknown entries in storage so a temporary connection issue can recover.
      var cleaned = results.filter(function (result) {
        return result.state !== 'missing';
      }).map(function (result) {
        return result.entry;
      });

      if (cleaned.length !== list.length) writeList(cleaned);
      removeUnverifiedCards(results);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', cleanRecentlyViewed, { once: true });
  } else {
    cleanRecentlyViewed();
  }

  document.addEventListener('shopify:section:load', cleanRecentlyViewed);
})();
